// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe {
  overflow-x: hidden;
  overflow-y: scroll !important;
  height: 94%;
}

.max-height {
  height: 100vh;
}

.container-fluid {
  padding: 0;
  border: 0;
}

.ispu-locator-header {
  background-color: rgba(233, 236, 239, 0.6);
  padding: 8px 0;
  color: #343a40;
  font-size: 1.5em;
  margin-left: 0;
  width: 100vw;
  z-index: 1;
  font-weight: 500;
  text-transform: uppercase;
  height: 6%;
}

.fa-arrow-left {
  cursor: pointer;
}

.close:hover {
  font-size: 1.6rem;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/cases/ispu/ispu-locator-wrapper.scss","webpack://./node_modules/edozvola-frontend-lib/dist/assets/css/00-settings/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,6BAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,UAAA;EACA,SAAA;AADF;;AAIA;EACE,0CCOW;EDNX,cAAA;EACA,cClBU;EDmBV,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,iBAAA;AADF","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\niframe {\n  overflow-x: hidden;\n  overflow-y: scroll !important;\n  height: 94%;\n}\n\n.max-height {\n  height: 100vh;\n}\n\n.container-fluid {\n  padding: 0;\n  border: 0;\n}\n\n.ispu-locator-header {\n  background-color: $gray-light;\n  padding: 8px 0;\n  color: $secondary;\n  font-size: 1.5em;\n  margin-left: 0;\n  width: 100vw;\n  z-index: 1;\n  font-weight: 500;\n  text-transform: uppercase;\n  height: 6%;\n}\n\n.fa-arrow-left {\n  cursor: pointer;\n}\n\n.close:hover {\n  font-size: 1.6rem;\n}\n","// Main colors\n$primary: #3a516e;\n$secondary: #343a40;\n\n// Misc Colors\n$green: #17aa55;\n$green-light: #88dda9;\n\n$red: #ca1820;\n$red-light: #d85b61;\n$red-lighter: #e9a7a9;\n$red-lightest: #f4d3d4;\n$yellow: #ffce00;\n\n$blue: #199cb4;\n$blue-light: #5fcde2;\n\n$primary-lighter: #607a9b;\n$primary-lightest: #aaccf8;\n\n$black: #000000;\n$white: #fff;\n\n$gray-dark: #828a90;\n$gray: #adb5bd;\n$gray-light: rgba(233, 236, 239, 0.6);\n$gray-lighter: #f4f5f7;\n\n// Alerts colors\n$success: #19b45a;\n$info: $blue;\n$warning: #f5d8d9;\n$danger: $primary;\n$default: $gray;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
